/**
 * @generated SignedSource<<8b21a4929b9c1a7e4a6c54f49857b46f>>
 * @relayHash bf09b9b63b3ebb697121f51351ef46c3
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bf09b9b63b3ebb697121f51351ef46c3

import { ConcreteRequest } from 'relay-runtime';
export type HealthInformationType = "ALLERGY" | "BODY_MEASUREMENT" | "CONDITION" | "FAMILY_HISTORY" | "GYNAECOLOGY" | "SOCIAL_HISTORY";
export type Ch_verifyHealthInformationInput = {
  appointmentId: string;
  healthInformationType: HealthInformationType;
  patientId: string;
};
export type chVerifyHealthInformationMutation$variables = {
  input: Ch_verifyHealthInformationInput;
};
export type chVerifyHealthInformationMutation$data = {
  readonly verifyHealthInformation: {
    readonly verifyHealthInformationOutput: {
      readonly healthInformationLastVerification: {
        readonly healthInformationType: HealthInformationType;
        readonly id: string;
        readonly patientId: string;
        readonly verifiedAt: string | null;
        readonly verifiedBy: string | null;
      };
      readonly healthInformationVerification: {
        readonly appointmentId: number;
        readonly healthInformationType: HealthInformationType;
        readonly id: string;
        readonly patientId: string;
        readonly verifiedAt: string | null;
        readonly verifiedBy: string | null;
      };
    } | null;
  };
};
export type chVerifyHealthInformationMutation = {
  response: chVerifyHealthInformationMutation$data;
  variables: chVerifyHealthInformationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "patientId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "healthInformationType",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "verifiedAt",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "verifiedBy",
  "storageKey": null
},
v6 = [
  {
    "alias": "verifyHealthInformation",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Ch_verifyHealthInformationPayload",
    "kind": "LinkedField",
    "name": "ch_verifyHealthInformation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "VerifyHealthInformationOutput",
        "kind": "LinkedField",
        "name": "verifyHealthInformationOutput",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "HealthInformationLastVerification",
            "kind": "LinkedField",
            "name": "healthInformationLastVerification",
            "plural": false,
            "selections": [
              (v1/*:: as any*/),
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "HealthInformationVerification",
            "kind": "LinkedField",
            "name": "healthInformationVerification",
            "plural": false,
            "selections": [
              (v1/*:: as any*/),
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "appointmentId",
                "storageKey": null
              },
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "chVerifyHealthInformationMutation",
    "selections": (v6/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "chVerifyHealthInformationMutation",
    "selections": (v6/*:: as any*/)
  },
  "params": {
    "id": "bf09b9b63b3ebb697121f51351ef46c3",
    "metadata": {},
    "name": "chVerifyHealthInformationMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "b18eeee24b6d65ccf8e4527eaeed147b";

export default node;
